import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../../store/auth-slice';
import BsArrowRightShort from '@meronex/icons/bs/BsArrowRightShort';
import moment from 'moment';
import { getConfig } from '../../../../utils/config';
import { Button } from '../../../../Components/Atoms';
import { cmsClient, winnreAuth, winnreNoAuth } from '../../../../utils/axios';
import {
    renderDate,
    titleCase,
    toIndianRs,
    toNumberFormat,
    truncate
} from '../../../../helpers';
import ReactGA from 'react-ga4';
import useTimer from '../../../../Hooks/use-timer';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { rewardCoinSvg, smallRewardCoinSvg } from '../Header/svg';
import { dealAction } from '../../../../store/deal-slice';
import store from '../../../../store';
import { cart, check } from './svg';
import BiCheck from '@meronex/icons/bi/BiCheck';
import { toast } from 'react-toastify';

import './style.css';
import Modal from '../../../../Components/Organisms/Modal';
import GrClose from '@meronex/icons/gr/GrClose';
import Fireworks from '../../../../Components/Atoms/FireWorks';
function DealsLayout({
    id,
    title,
    endDate,
    displayImageUrl,
    vendorLogoUrl,
    vendorName,
    hideVendorLogo,
    fromProductPage,
    productMrp,
    productConvenienceFee,
    productShippingFee,
    points,
    thumbnailImageUrl,
    tags,
    categoryName,
    isRewards,
    rewardStorePoint,
    className
}) {
    const preLoginWebview = useSelector(
        (state) => state.webView.preLoginWebview
    );

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const config = getConfig();
    const [itemAdded, setItemAdded] = useState(false);
    const [disableCart, setDisableCart] = useState(false);
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    // console.log('total rewards from deal layout', totalRewardspoint);
    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };
    const userId = useSelector((state) => state.auth.userId);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    const dealClickedHandler = () => {
        if (
            cmsClient.defaults.baseURL === 'https://prod.loyalie.in' ||
            cmsClient.defaults.baseURL === 'https://uat.loyalie.in'
        ) {
            window.fbq('trackCustom', 'GrabOfferButtonClicked');
        }
        ReactGA.event({
            category: 'OFFER',
            action: 'GRAB OFFER CLICKED',
            label: 'GRAB OFFER BUTTON'
        });
        var valueToSend = { message: 'OPEN_LOGIN' };
        if (!isAuthenticated && preLoginWebview) {
            // console.log('app login');
            window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                valueToSend
            );
            window?.JSBridge?.showMessageInNative('OPEN_LOGIN');
            return;
        }
        if (isAuthenticated) {
            winnreAuth({
                method: 'POST',
                url: `winnre/user/deals/trackClick?dealId=${id}&userId=${userId}`
            })
                .then(() => {})
                .catch(() => {});
        } else {
            winnreNoAuth({
                method: 'POST',
                url: `winnre/user/deals/trackClick?dealId=${id}`
            })
                .then(() => {})
                .catch(() => {});
        }
        if (isAuthenticated) {
            const routePath =
                isRewards === true ? `/rewardStore/${id}` : `/deals/${id}`;
            history.push(routePath);
        } else {
            const routePath = isRewards === true ? `/rewardStore` : `/deals`;
            if (fromProductPage) {
                history.push(
                    `${location.pathname}${location.search}?postLoginUrl=${routePath}/${id}`
                );
            } else {
                history.push(`${routePath}?postLoginUrl=${routePath}/${id}`);
            }
            openLoginModal();
        }
    };

    // On cart click

    const OnCartClick = () => {
        window?.webengage?.track('AddToCartClicked', {
            category: `${categoryName}`,
            ProductName: `${title}`,
            Price: `${productMrp}`,
            PointsRequired: `${points}`
        });
        const oldCartData = localStorage.getItem('cartData');
        let currentMrp = 0;
        let totalCartCount = 0;
        let totalShippingFee = 0;
        let totalConvenienceFee = 0;
        let totalPoints = 0;
        let cartData = {
            cartValues: [],
            totalMrp: currentMrp,
            totalPoints: totalPoints,
            totalShippingFee: totalShippingFee,
            totalConvenienceFee: totalConvenienceFee,
            totalProduct: totalCartCount
        };

        if (oldCartData) {
            cartData = JSON.parse(oldCartData);
        }
        console.log(
            'currentPoints',
            points,
            'cartTotal',
            cartData?.totalPoints,
            'rewardsTotal',
            totalRewardspoint
        );
        if (
            totalRewardspoint > 0 &&
            points + cartData?.totalPoints > totalRewardspoint
        ) {
            setDisableCart(true);
            toast("You don't have enough reward points to redeem this item.");
            return;
        }
        handleClick();
        // Add the new product to cartValues
        cartData.cartValues.push({
            id: id,
            title: title,
            endDate: endDate,
            displayImageUrl: displayImageUrl,
            vendorLogoUrl: vendorLogoUrl,
            productMrp: productMrp,
            thumbnailImageUrl: thumbnailImageUrl,
            points: points,
            productShippingFee: productShippingFee,
            productConvenienceFee: productConvenienceFee,
            tags: tags
        });

        // Update totalMrp and totalProduct
        cartData.totalMrp += productMrp;
        cartData.totalShippingFee += productShippingFee;
        cartData.totalConvenienceFee += productConvenienceFee;
        cartData.totalProduct += 1;
        cartData.totalPoints += points;

        // Save updated cart data to localStorage
        localStorage.setItem('cartData', JSON.stringify(cartData));
        // Dispatch a custom event to notify other components
        dispatch(dealAction.setCartModalVisible(true));
        window.dispatchEvent(new Event('cartUpdated'));
        // const state = store.getState(); // Access the current store state
        // const isRefresh = !state.deals.isRefreshRewards;
        // dispatch(dealAction.setIsRewardRefreshing(isRefresh));
        console.log(cartData);
    };

    const handleClick = () => {
        if (!itemAdded) {
            setItemAdded(true);
            setTimeout(() => {
                setItemAdded(false);
                const state = store.getState(); // Access the current store state
                const isRefresh = !state.deals.isRefreshRewards;
                dispatch(dealAction.setIsRewardRefreshing(isRefresh));
            }, 2000); // Reset after 2 seconds
        }
    };

    //bg-gray-800 rounded-lg overflow-hidden transition-all duration-500 ease-in-out transform hover:scale-105 hover:shadow-lg hover:bg-gradient-to-t hover:from-white/10 hover:via-white/20 hover:to-transparent
    return (
        <>
            <div
                onClick={dealClickedHandler}
                // className={`rounded-2xl shadow-lg hover:shadow-xl flex-none cursor-pointer w-[300px] h-full ${
                //     isRewards ? 'bg-[#EDEEF0]' : 'bg-[#130E2F]'
                // } `}
                className={`rounded-2xl shadow-lg  hover:shadow-xl flex-none cursor-pointer  h-full bg-[#EDEEF0] border border-[#e0e1e1] ${
                    className
                        ? className
                        : categoryName == 'External'
                        ? 'w-[45%] md:w-[47%] lg:w-[30%]'
                        : 'xl:w-[300px] lg:w-[300px] card_section md:w-[200px] w-[165px]'
                }`}
            >
                <div className=" flex flex-col ">
                    <div
                        // className={`relative ${
                        //     isRewards ? 'group overflow-hidden' : ''
                        // } `}
                        className={`relative group overflow-hidden`}
                    >
                        <img
                            loading="lazy"
                            src={
                                thumbnailImageUrl
                                    ? thumbnailImageUrl
                                    : displayImageUrl
                            }
                            className={`${
                                categoryName === 'External'
                                    ? 'w-full h-full'
                                    : 'object-cover w-full h-[165px] md:h-[200px] card_img lg:h-[300px]'
                            } rounded-t-2xl ${isRewards ? '' : ''} `}
                            alt={`deal`}
                        />

                        {!hideVendorLogo &&
                            !isRewards &&
                            categoryName !== 'External' && (
                                <img
                                    src={vendorLogoUrl}
                                    className="absolute top-2 right-2 md:top-3 md:right-3 w-[45px] h-[45px] md:w-[60px] md:h-[60px] rounded-lg shadow-lg"
                                    alt="Vendor Logo"
                                />
                            )}
                        <div
                            // className={`${
                            //     isRewards
                            //         ? 'animate-shine shine-line group-hover:opacity-30 opacity-0'
                            //         : ''
                            // } `}
                            className={`animate-shine shine-line group-hover:opacity-30 opacity-0`}
                        ></div>
                    </div>
                    <div
                        className={`flex flex-col  xl:p-4 lg:p-2 p-2 rounded-b-2xl ${
                            isRewards ? '' : ''
                        }`}
                    >
                        <p className="text-primary uppercase font-bold text-sm pb-1">
                            {vendorName}
                        </p>
                        <h1
                            className={`text-xs md:text-sm lg:text-sm ${
                                categoryName == 'External'
                                    ? 'h-6'
                                    : 'h-9 md:h-10 lg:h-10 xl:h-10'
                            }  leading-2 text-black multi-line-ellipsis`}
                        >
                            {/* {isRewards ? title : titleCase(title) }    */}
                            {title}
                        </h1>
                        <div
                            className={`flex justify-between  mt-2 ${
                                isRewards
                                    ? 'flex-col gap-2'
                                    : 'flex flex-col-reverse flex-col  lg:flex-row lg:items-center  '
                            }`}
                        >
                            <div className="flex justify-start">
                                <button
                                    className={` font-semibold ${
                                        config?.darktheme
                                            ? config?.deals?.darkTheme?.text
                                            : isRewards
                                            ? 'text-gray-700'
                                            : 'text-primary'
                                    } ${
                                        isRewards
                                            ? ' line-through text-xs md:text-sm lg:text-sm'
                                            : 'text-xs'
                                    }`}
                                >
                                    {isRewards
                                        ? toIndianRs(productMrp)
                                        : 'Know more >'}
                                </button>
                                {isRewards && (
                                    <div>
                                        <h4 className="text-xs md:text-sm lg:text-sm font-semibold ml-2  text-primary">
                                            {/* Grab it for free  */}
                                            Buy at {toIndianRs(99)}
                                        </h4>
                                    </div>
                                )}
                            </div>
                            {isRewards === true ? (
                                <button
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        if (rewardStorePoint) {
                                            history.push(`/rewardStore/${id}`);
                                        } else if (!itemAdded) {
                                            OnCartClick(); // Call only if the button is not already clicked
                                        } // Prevent event bubbling

                                        // if (!itemAdded) OnCartClick();
                                    }}
                                    className={` text-white w-full p-2 mt-1 rounded-md transition duration-200 flex items-center gap-1 justify-center cursor-pointer ${
                                        itemAdded || disableCart
                                            ? 'bg-[#77a0d6]'
                                            : 'bg-[#16519E]'
                                    }`}
                                    disabled={disableCart || itemAdded}
                                >
                                    {/* {itemAdded ? (
                                        <>
                                            {check} 
                                            <span className="text-[11px] md:text-sm lg:text-sm">
                                                Added to Gift Basket
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            {cart} 
                                            <span className="text-[11px] md:text-sm lg:text-sm">
                                                Add to Gift Basket
                                            </span>
                                        </>
                                    )} */}
                                    {rewardStorePoint ? (
                                        <span className="text-[11px] md:text-sm lg:text-sm">
                                            View More Info
                                        </span>
                                    ) : itemAdded ? (
                                        <>
                                            {check} {/* Check icon */}
                                            <span className="text-[11px] md:text-sm lg:text-sm">
                                                Added to Gift Basket
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            {cart} {/* Cart icon */}
                                            <span className="text-[11px] md:text-sm lg:text-sm">
                                                Add to Gift Basket
                                            </span>
                                        </>
                                    )}
                                </button>
                            ) : (
                                <div>
                                    <p
                                        className={`${config?.deals?.dealLayout?.listBodyClass} text-[12px] italic text-gray-900 `}
                                    >
                                        Valid till: {renderDate(endDate)}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Fireworks itemAdded={itemAdded} />
        </>
    );
}

export default DealsLayout;
